"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(nodeId) {
    return ['CLUSTER', 'FORGET', nodeId];
}
exports.transformArguments = transformArguments;
